import React, { useMemo } from "react";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import DataGrid from "devextreme-react/data-grid";
import {
  GetTransactionHeaderGridData,
  GetItemMasterGridData,
  GetItemLotGridData,
  GetLocationMasterGridData,
} from "../services/ItemManagementService";
import { ITEM_COLUMNS, LOT_COLUMNS, LOCATION_COLUMNS } from "../transactionsTab/referenceColumns";
import { TRANSACTION_HEADER_COLUMNS } from "../itemMasterTab/subTabColumns";

// Shared read-only sub-grid (same look/height/paging as the other bottom sub-grids).
const SubGrid = ({ data, columns }) => (
  <div style={{ height: 305 }}>
    <DataGrid
      dataSource={data}
      columns={columns}
      remoteOperations={true}
      showBorders={true}
      columnAutoWidth={true}
      height="100%"
      sorting={{ mode: "multiple" }}
      filterRow={{ visible: true }}
      headerFilter={{ visible: true }}
      columnChooser={{ enabled: true }}
      export={{ enabled: true }}
      paging={{ pageSize: 20 }}
      pager={{ visible: true, showPageSizeSelector: true, allowedPageSizes: [20, 50, 100], showInfo: true }}
    />
  </div>
);

// Bottom sub-tabs for the Location Master top tab (Delphi IMD0046). Per the Delphi screen these are NOT
// linked to the selected location — each shows the full unfiltered result set for its own type.
function LocationMasterSubTabs(props) {
  const { accessToken } = props;
  const openTransStore = useMemo(() => GetTransactionHeaderGridData(accessToken, false), [accessToken]);
  const histTransStore = useMemo(() => GetTransactionHeaderGridData(accessToken, true), [accessToken]);
  const itemStore = useMemo(() => GetItemMasterGridData(accessToken), [accessToken]);
  const lotStore = useMemo(() => GetItemLotGridData(accessToken), [accessToken]);
  const locationStore = useMemo(() => GetLocationMasterGridData(accessToken), [accessToken]);

  return (
    <TabPanel deferRendering={true} animationEnabled={false}>
      <TabItem title="Open Transactions"><SubGrid data={openTransStore} columns={TRANSACTION_HEADER_COLUMNS} /></TabItem>
      <TabItem title="Historical Transactions"><SubGrid data={histTransStore} columns={TRANSACTION_HEADER_COLUMNS} /></TabItem>
      <TabItem title="Item Master"><SubGrid data={itemStore} columns={ITEM_COLUMNS} /></TabItem>
      <TabItem title="Item/Lot"><SubGrid data={lotStore} columns={LOT_COLUMNS} /></TabItem>
      <TabItem title="Location Master"><SubGrid data={locationStore} columns={LOCATION_COLUMNS} /></TabItem>
    </TabPanel>
  );
}

export default LocationMasterSubTabs;
